var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9377 0.653122C15.7927 0.259122 15.4197 0.00012207 15.0007 0.00012207H0.999707C0.580707 0.00012207 0.208707 0.259122 0.0627071 0.653122C-0.0832929 1.04712 0.0317071 1.48612 0.349707 1.75912L7.34971 7.75912C7.72271 8.07912 8.27771 8.07912 8.65071 7.75912L15.6507 1.75912C15.9687 1.48612 16.0837 1.04712 15.9377 0.653122Z",
    fill: "#808D96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.b739969521f01b6f1401c16b3419dd0c.svg";
export { ForwardRef as ReactComponent };